module.exports = __webpack_public_path__ + "src/assets/img/04_5art_3part_gallery.97468457.jpg";